// Google Analytics 4 forwarding for the WebPlayer's ANALYTICS events.
// Consent-gated via TCF Vendor 755 (Google) + Purpose 1; ad-personalisation
// additionally needs Purpose 3 or 4. gtag.js is loaded once, at the first
// moment consent is granted (initial banner accept OR late opt-in through the
// Privacy Center).
//
// A synchronous gtag() stub is installed at module load so any event emitted
// before gtag.js is on the page is queued in dataLayer and replayed once it
// arrives — we never drop events.

import { ENV } from './env.js';
import { LANG } from './i18n.js';

window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

let gaLoaded = false;

export function watchGaConsent() {
  if (!ENV.gaMeasurementId) return;
  if (typeof window.__tcfapi !== 'function') {
    // TCF stub not on the page yet — retry shortly.
    let n = 0;
    const iv = setInterval(() => {
      if (typeof window.__tcfapi === 'function') { clearInterval(iv); watchGaConsent(); }
      else if (++n > 100) clearInterval(iv);
    }, 100);
    return;
  }
  window.__tcfapi('addEventListener', 2, (data, ok) => {
    if (!ok || gaLoaded) return;
    const p = data?.purpose?.consents || {};
    const googleVendor = !!data?.vendor?.consents?.[755];
    // analytics_storage / ad_storage / ad_user_data all key off Purpose 1 +
    // Google vendor consent. If either is missing we don't load gtag at all.
    if (!(p[1] && googleVendor)) return;
    gaLoaded = true;
    window.__tcfapi('removeEventListener', 2, () => {}, data.listenerId);
    loadGa(!!(p[3] || p[4])); // ad_personalization additionally needs P3 or P4
  });
}

function loadGa(adsPersonal) {
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ENV.gaMeasurementId}`;
  document.head.appendChild(s);

  window.gtag('js', new Date());
  window.gtag('consent', 'default', {
    ad_storage:         'granted',
    analytics_storage:  'granted',
    ad_user_data:       'granted',
    ad_personalization: adsPersonal ? 'granted' : 'denied',
  });
  window.gtag('config', ENV.gaMeasurementId, {
    send_page_view: false,
    allow_google_signals: adsPersonal,
    allow_ad_personalization_signals: adsPersonal,
  });
  window.gtag('set', {
    platform_name: 'embedded',
    platform_group: 'web',
    language: LANG,
    embed_origin: parseHostname(document.referrer) || 'unknown',
  });
}

function parseHostname(url) {
  if (!url) return '';
  try { return new URL(url).hostname; } catch { return ''; }
}
